import { Plus } from 'lucide-react';

interface FloatingActionButtonProps {
  onClick: () => void;
}

export function FloatingActionButton({ onClick }: FloatingActionButtonProps) {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-8 right-8 w-14 h-14 bg-[#1B365D] hover:bg-[#2D4A7C] text-white rounded-full flex items-center justify-center shadow-lg transition-colors z-30"
      aria-label="Add expense"
    >
      <Plus size={24} />
    </button>
  );
}
